import { ReactNode } from 'react';
import Modal from "react-modal";

import * as S from './styles';

interface ModalProps {
  title?: string;
  text?: string;
  children?: ReactNode;
  isOpen: boolean;
  onRequestClose?: () => void;
  confirmButtonText?: string;
  confirmButtonClick?: () => void;
  cancelButtonText?: string;
  cancelButtonClick?: () => void;
  isConfirmFetching?: boolean;
  isCancelFetching?: boolean;
}

export function AlertModal({
  title = 'Alerta',
  isOpen = false,
  text,
  children,
  onRequestClose,
  confirmButtonText = 'Okay',
  confirmButtonClick, 
  cancelButtonText = 'Cancelar',
  cancelButtonClick,
  isCancelFetching = false,
  isConfirmFetching = false
}: ModalProps) {

  function handleCancelClick() {
    cancelButtonClick ? cancelButtonClick() : onRequestClose && onRequestClose();
  }

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentElement={(props, children) => (
        <S.ModalContent {...props}>{children}</S.ModalContent>
      )}
      overlayElement={(props, element) => (
        <S.ActiveModalOverlay {...props}>{element}</S.ActiveModalOverlay>
      )}
      className="active-content"
      overlayClassName="active-overlay"
    >
      <S.Body>
        <h2>{title}</h2>

        {children ?? <p>{text}</p>}
      </S.Body>

      <S.Footer>
        <S.AlertButton 
          variant='onboarding' 
          onClick={handleCancelClick} 
          isFetching={isCancelFetching}
          disabled={isConfirmFetching}
        >
          {cancelButtonText}
        </S.AlertButton>
        <S.AlertButton
          variant='primary'
          onClick={confirmButtonClick} 
          isFetching={isConfirmFetching}
          disabled={isCancelFetching}
        >
          {confirmButtonText}
        </S.AlertButton>
      </S.Footer>
    </Modal>
  )
}